import React, { useRef, useEffect } from "react";

const MAX_LENGTH = 280;

const CommentaryInput = ({ commentary, onUpdateCommentary }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [commentary]);

  return (
    <div className="px-6 py-4">
      <textarea
        ref={textareaRef}
        id="share-commentary"
        value={commentary}
        onChange={(e) => onUpdateCommentary(e.target.value)}
        placeholder="Say something..."
        maxLength={MAX_LENGTH}
        autoFocus
        aria-describedby="share-commentary-counter"
        className="w-full bg-[#F9FAFB] rounded-2xl p-4 text-gray-800 placeholder-gray-400 focus:outline-none min-h-[100px] resize-none border-none transition-[height] duration-200"
      />
      <div
        id="share-commentary-counter"
        className={`text-xs text-right mt-1 ${commentary.length >= MAX_LENGTH ? 'text-red-500' : commentary.length >= 220 ? 'text-yellow-500' : 'text-gray-400'}`}
        aria-live="polite"
        aria-atomic="true"
      >
        {commentary.length}/{MAX_LENGTH}
      </div>
    </div>
  );
};

export default CommentaryInput;
